module.exports = __webpack_public_path__ + "static/media/whiteDiamon.19552ee7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/whiteDiamon.svg
// module id = 185
// module chunks = 0